import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { GripVertical, MessageCircle, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/Card';
import { Avatar } from '../ui/Avatar';
import { Deal } from '../../types';
import { formatCurrency, formatRelativeTime } from '../../utils/format';
interface DealCardProps {
  deal: Deal;
}
export function DealCard({
  deal
}: DealCardProps) {
  const navigate = useNavigate();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging
  } = useDraggable({
    id: deal.id
  });
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
  } : undefined;
  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate('/whatsapp');
  };
  if (isDragging) {
    return <div ref={setNodeRef} style={style} className="opacity-50 grayscale" data-id="element-65">
        <Card className="p-4 bg-slate-800 border-slate-700" data-id="element-66">
          <div className="h-20" data-id="element-67"></div>
        </Card>
      </div>;
  }
  return <div ref={setNodeRef} style={style} {...attributes} data-id="element-68">
      <Card className="p-4 cursor-grab active:cursor-grabbing hover:ring-2 hover:ring-primary/50 transition-all group bg-slate-800 border-slate-700" hover data-id="element-69">
        <div className="flex justify-between items-start mb-3" data-id="element-70">
          <h4 className="font-bold text-white text-sm line-clamp-1" data-id="element-71">
            {deal.storeName}
          </h4>
          <div {...listeners} className="cursor-grab p-1 -mr-2 -mt-2 hover:bg-slate-700 rounded" data-id="element-72">
            <GripVertical className="h-4 w-4 text-slate-600 group-hover:text-slate-400" data-id="element-73" />
          </div>
        </div>

        <div className="flex items-center justify-between mb-3" data-id="element-74">
          <span className="text-xs text-text-muted" data-id="element-75">{deal.contactName}</span>
          <span className="text-sm font-bold text-emerald-400" data-id="element-76">
            {formatCurrency(deal.estimatedValue)}
          </span>
        </div>

        <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-700/50" data-id="element-77">
          <div className="flex items-center gap-2" data-id="element-78">
            <Avatar src={deal.responsibleSeller.avatar} fallback={deal.responsibleSeller.name} size="xs" data-id="element-79" />
            <div className="flex items-center text-[10px] text-text-muted" data-id="element-80">
              <Clock className="h-3 w-3 mr-1" data-id="element-81" />
              {formatRelativeTime(deal.lastContact)}
            </div>
          </div>

          <button onClick={handleWhatsAppClick} className="p-1.5 rounded-full bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500 hover:text-white transition-colors" data-id="element-82">
            <MessageCircle className="h-3.5 w-3.5" data-id="element-83" />
          </button>
        </div>
      </Card>
    </div>;
}